import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=c4fce330&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4fce330')) {
      api.createRecord('c4fce330', component.options)
    } else {
      api.reload('c4fce330', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=c4fce330&", function () {
      api.rerender('c4fce330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SwBIqHg4LGK4/JS/offershelp.vue"
export default component.exports